<template>
	<div v-if="fBase != null" class="cnt-smart-table">
		<appBox
			v-if="data.filtros != undefined && data.filtros.length > 0"
			title='<i class="fa fa-filter"></i> Filtro(s)'
		>
			<div slot="tools">
				<button @click="search" class="btn btn-primary btn-sm">
					Pesquisar
				</button>
			</div>
			<div slot="body">
				<div class="row">
					<div
						v-for="(input, id) in filters"
						:class="'col-sm-' + input.col"
					>
						<span v-if="input.type != 'msg'">{{
							input.label
						}}</span>
						<ch-input :data="input"></ch-input>
						<ch-select :data="input"></ch-select>
					</div>
				</div>
			</div>
		</appBox>
		<appBox :title="data.titulo">
			<div slot="tools" class="pull-right">
				<actionMenu
					:tid="data.cod"
					:inputs="fBase.inputs"
					@register="$refs.modal.open()"
					@openSettings="$emit('openSettings')"
					@updateTable="$refs.table.updateTable()"
					@returnBase="$emit('returnBase')"
				/>
			</div>
			<div slot="body">
				<sTable
					ref="table"
					actionRead="protected-read-smartTablesItems:LoadData"
					actionDelete="private-delete-smartTables:items"
					:labels="processorLabels"
					:actions="['delete', 'edit']"
					:compData="{ cod: data.cod }"
					:functions="processorFunctions"
					@edit="(val) => $refs.modal.open(val)"
					debug
					noOrder
				/>
				<!-- :filterFx = 'filter_datatable' -->
			</div>
		</appBox>
		<appModal
			ref="modal"
			:fBase="fBase"
			:tid="data.cod"
			@updateTable="$refs.table.updateTable()"
		/>
	</div>
</template>
<script>
	import appBox from 'app/box';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import clone from 'js/clone';
	import ChInput from '../../create-form/inputs/chInputs.vue'; //"../inputs/chInputs.vue"
	import ChSelect from '../../create-form/inputs/chSelect.vue';
	import actionMenu from './action-menu.vue';
	import appModal from './modal.vue';
	import sTable from 'table';
	import { camelCase } from 'lodash';

	export default {
		name: 'loadTable',
		props: ['data', 'fBase'],
		components: { appBox, ChInput, appModal, ChSelect, actionMenu, sTable },
		data() {
			return {
				filters: [],
			};
		},
		methods: {
			reloadTable() {
				this.mount_filter();
				this.$refs.table.setFilter({});
				this.$refs.table.updateTable();
			},
			search() {
				const filter = this.filters.reduce((acc, item) => {
					if (item.value != '') {
						if (item.type == 'select') acc[item.id] = item.value;
						else acc[item.id] = `%${item.value}%`;
					}
					return acc;
				}, {});

				this.$refs.table.setFilter(filter);
				this.$refs.table.updateTable();
			},
			// filter_datatable(data){
			// 	if(data.pre_requestData == null) return []
			// 	return data.pre_requestData.filter( item => {
			// 		let loc = ""
			// 		this.filters.forEach( fItem => {
			// 			if(fItem.type == "text"){
			// 				let term = item[fItem.id].toLowerCase()
			// 				if(term == "") {
			// 					loc += "1"
			// 				}else{
			// 					let val = fItem.value.toLowerCase()
			// 					if(term.indexOf(val) != -1){
			// 						loc += "1"
			// 					}else {
			// 						loc += "0"
			// 					}
			// 				}
			// 			}else{
			// 				if(fItem.value == "") loc += "1"
			// 				else if( camelCase(fItem.value) == camelCase(item[fItem.id]) ) loc += "1"
			// 				else loc += "0"
			// 			}
			// 		})
			// 		if(loc.indexOf("0") == -1) return item
			// 	})
			//    },
			mount_filter() {
				this.filters = [];
				if (
					this.data.filtros != undefined &&
					this.data.filtros.length > 0
				) {
					let inpts = clone(this.fBase.inputs);
					this.data.filtros.forEach((item) => {
						let inp = inpts.find((i) => i.id == item);
						if (inp != undefined) {
							if (inp.type == 'text' || inp.type == 'select') {
								this.filters.push(inp);
							}
						}
					});
				}
			},
		},
		computed: {
			processorLabels() {
				let labels = [];
				this.data.exibir.forEach((item) => {
					if (this.fBase.inputs != undefined) {
						let inp = this.fBase.inputs.find(
							(input) => input.id == item
						);
						if (inp != undefined) {
							labels.push({ data: item, label: inp.label });
						}
					}
				});
				return clone(labels);
			},

			// date
			// select
			// checkbox
			// radio

			processorFunctions() {
				let resp = [];
				this.data.exibir.forEach((item) => {
					if (this.fBase.inputs != undefined) {
						let input = this.fBase.inputs.find(
							(inp) => inp.id == item
						);
						if (input != undefined) {
							const exceptions = [
								'number',
								'text',
								'textarea',
								'mask',
								'password',
								'table',
								'msg',
							];
							if (exceptions.indexOf(input.type) == -1) {
								if (input.type == 'date') {
									resp.push({
										cod: input.id,
										fx: (val) => {
											if (val == '') return '##/##/####';
											return val
												.split('-')
												.reverse()
												.join('/');
										},
									});
								} else {
									resp.push({
										cod: input.id,
										fx: (val) => {
											let gVal =
												input.options.options.find(
													(opt) =>
														camelCase(opt.value) ==
														camelCase(val)
												);
											return gVal != undefined
												? gVal.text
												: val;
										},
									});
								}
							}
						}
					}
				});
				return resp;
			},
		},
		mounted() {},
	};
</script>
<style scoped>
	.cnt-table {
		overflow: auto;
		width: 100%;
	}
	.table {
		width: max-content;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/tables/components/view-table.vue